import React from 'react'
import { XAxis, Tooltip, CartesianGrid, Line, LineChart, YAxis, Legend, ResponsiveContainer } from 'recharts'
import right from '../../images/right-arrow (2) 1.png'
import line from '../../images/Group 1171275371.png'
import line2 from '../../images/Group 1171275372.png'
const ForeCasting = () => {
    const data = [
        {
            "name": "2021-01-01",
            "Sales": 4000,
            "Unit Sold": 2400,
            "amt": 2400
        },
        {
            "name": "2021-01-01",
            "Sales": 3000,
            "Unit Sold": 1398,
            "amt": 2210
        },
        {
            "name": "2021-01-01",
            "Sales": 2000,
            "Unit Sold": 9800,
            "amt": 2290
        },
        {
            "name": "2021-01-01",
            "Sales": 2780,
            "Unit Sold": 3908,
            "amt": 2000
        },
        {
            "name": "2021-01-01",
            "Sales": 1890,
            "Unit Sold": 4800,
            "amt": 2181
        },
        {
            "name": "2021-01-01",
            "Sales": 2390,
            "Unit Sold": 3800,
            "amt": 2500
        },
        {
            "name": "2021-01-01",
            "Sales": 3490,
            "Unit Sold": 4300,
            "amt": 2100
        }
    ]
    return (
        <>
            <div className='forecasting_wrapper'>
                <div className='invoice_creation_head'>Forecasting of budget vs completion</div>
                <div className='forecasting_revenue_wrapper'>
                    <div className='forecasting_left'>
                        <h5>REVENUE</h5>
                        <h2>$2878.<span>90</span></h2>
                        <h6>42+Since Last Week</h6>
                        <div className='yellow_dollar_div'>$2014.60</div>
                        <div className='black_dollar_div'>$864.30</div>
                    </div>

                    <div className='forecasting_right_chart'>
                        <div className='total_wrapper'>Total summary in
                            <div className='monthly_wrapper'>Monthly <img style={{
                                width: '8px'
                            }} src={right} />
                            </div>


                            <div className='monthly_wrapper'>Set Track <img style={{
                                width: '8px'
                            }} src={right} />
                            </div>
                        </div>
                        <ResponsiveContainer width="98%" height={450}>
                            <LineChart width={'100%'} height={'100%'} data={data}
                            >
                                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                <XAxis dataKey="name" />
                                <YAxis />

                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="Sales" strokeWidth={4} stroke="#FFDD00" />
                                <Line type="monotone" dataKey="Unit Sold" strokeWidth={4} stroke="#0C2537" />
                            </LineChart>
                        </ResponsiveContainer>


                    </div>
                </div>

                <div className='forecasting_cards_wrapper'>
                    <div className='forecasting_card'>
                        <div className='forecasting_sales_wrapper'>
                            <p>Sales</p>
                            <p>+22%</p>
                        </div>
                        <div className='revenue_line_wrapper'>
                            <h3>$9,520</h3>
                            <img src={line} />
                        </div>
                    </div>


                    <div className='forecasting_card'>
                        <div className='forecasting_sales_wrapper'>
                            <p>Average Sales per day</p>
                            <p>-3%</p>
                        </div>
                        <div className='revenue_line_wrapper'>
                            <h3>$425</h3>
                            <img src={line2} />
                        </div>
                    </div>



                    <div className='forecasting_card'>
                        <div className='forecasting_sales_wrapper'>
                            <p>Unit Sold</p>
                            <p>+22%</p>
                        </div>
                        <div className='revenue_line_wrapper'>
                            <h3>$9,520</h3>
                            <img src={line} />
                        </div>
                    </div>



                    <div className='forecasting_card' style={{
                        backgroundColor:'#ffdd00',
                        padding:'40px 20px'
                    }}>
                        <div className='forecasting_sales_wrapper'>
                            <p>Average Sales per day</p>
                            <p>+22%</p>
                        </div>
                        <div className='revenue_line_wrapper'>
                            <h3>$9,520</h3>
                            <img src={line} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForeCasting
